"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortOrder = exports.RowHeaders = void 0;
var RowHeaders;
(function (RowHeaders) {
    RowHeaders["None"] = "None";
    RowHeaders["Date"] = "Date";
})(RowHeaders || (exports.RowHeaders = RowHeaders = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["Asc"] = "asc";
    SortOrder["Desc"] = "desc";
})(SortOrder || (exports.SortOrder = SortOrder = {}));
